module.exports = __webpack_public_path__ + "img/WEICHAI-icon.8bb5a089.png";